import request from '@/utils/request'

/**
 * 获取行业动态列表信息
 * @param {} data
 * @returns
 */
export function getNewList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetConsultingServiceTList',
        method: 'post',
        params: data
    })
}


/**
 * 获取行业动态列表信息
 * @param {} data
 * @returns
 */
export function GetNoticeList(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetNoticeList',
        method: 'post',
        params: data
    })
}

/**
 * 获取轮播图
 * @param {} data
 * @returns
 */
export function getCarouselSlideList() {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetCarouselmap',
        method: 'post',
    })
}

/**
 * 获取实用工具
 * @param {} data
 * @returns
 */
export function getUtilitiesList() {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetUtilities',
        method: 'post',
    })
}

/**
 * 获取地质特征查询
 * @param {} data
 * @returns
 */
export function getGeologicalfeatureList() {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetGeologicalfeature',
        method: 'post',
    })
}


/**
 * 煤炭管理跳转方法
 * @param {} data
 * @returns
 */
export function CoalManagementJump(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/CoalManagementJump',
        method: 'post',
        params: data
    })
}

export function CoalZhiwangInfo(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/CoalZhiwangInfo',
        method: 'post',
        data
    })
}
export function CoalZhiwangWenxianInfo(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/CoalZhiwangWenxianInfo',
        method: 'post',
        data
    })
}


// 文献
export function NewCoalZhiwangWenxianInfo(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/NewCoalZhiwangWenxianInfo',
        method: 'post',
        data
    })
}

export function NewCoalZhiwangInfo(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/NewCoalZhiwangInfo',
        method: 'post',
        data
    })
}
// 文献list


/**
 * 工程数据跳转方法
 * @param {} data
 * @returns
 */
export function GetSYSIDDataByzhiwang(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/HomeQuery/GetSYSIDDataByzhiwang',
        method: 'post',
        params: data
    })
}



// 云Gis图库
export function GetProject(data) {
  return request({
      baseURL: process.env.VUE_APP_Dzy,
      url: '/api/GCProjectinfo/GetTheData',
      method: 'post',
      params: data
  })
}
export function GetGisTree(data) {
  return request({
      baseURL: process.env.VUE_YunGIS_API,
      url: '/api/sys/layerauth/getGroupLayerByMineName',
      method: 'get',
      params: data
  })
}
export function GetGisLayer(data) {
  return request({
      baseURL: process.env.VUE_YunGIS_API,
      url: '/api/gis/mapserver/rest/layers',
      method: 'get',
      params: data
  })
}
export function GetGisImg(data) {
    return request({
        baseURL: process.env.VUE_YunGIS_API,
        url: '/api/gis/mapserver/rest/ext',
        method: 'post',
       // responseType: "blob",
        responseType:"arraybuffer",
        data
    })
}
export function GetGisImg2(data) {
  return request({
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      baseURL: process.env.VUE_YunGIS_API,
      url: '/api/gis/mapserver/rest/ext',
      method: 'post',
     // responseType: "blob",
      responseType:"arraybuffer",
      data
  })
}

export function GetGisID(str) {
  return request({
      baseURL: process.env.VUE_YunGIS_API,
      url: '/api/sys/file/info/' + str + ".lfmx",
      method: 'get',
  })
}

export function GetMapScale(data) {
  return request({
      baseURL: process.env.VUE_YunGIS_API,
      url: '/api/gis/mapserver/rest/maps',
      method: 'get',
      params: data
  })
}



// 项目设计--工作量设计--钻孔--同步设计钻孔数据
export function GetSynchronousDrill(data) {
  return request({
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      baseURL: process.env.VUE_YunGIS_API,
      url: '/api/gis/mapserver/rest/feature/query',
      method: 'post',
      data,
  })
}




// WEBPACK FOOTER //
// ./src/api/Index.js